/**
 * Celular com cache antigo: recarrega uma vez quando a versão dos assets muda.
 * O preview do admin não usa o mesmo cache do Safari/Chrome no aparelho.
 */
(function () {
  function readAssetVersion() {
    var build = document.documentElement.getAttribute('data-mercadao-build');
    if (!build) return '2026061001';
    var parts = build.split('-');
    return parts[parts.length - 1] || build;
  }

  const ASSET_VERSION = readAssetVersion();
  const STORAGE_KEY = 'mercadao-asset-v';
  const isCoarse =
    window.matchMedia('(pointer: coarse)').matches ||
    window.matchMedia('(max-width: 989px)').matches;

  if (!isCoarse) return;

  try {
    const previous = localStorage.getItem(STORAGE_KEY);
    if (previous && previous !== ASSET_VERSION) {
      localStorage.setItem(STORAGE_KEY, ASSET_VERSION);
      window.location.reload();
      return;
    }
    localStorage.setItem(STORAGE_KEY, ASSET_VERSION);
  } catch (_) {
    /* modo privado */
  }
})();
